import React from 'react';

const Helps = () => {
  return <div>Helps</div>;
};

export default Helps;
